import { AlertTriangle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import T from "../theme/colors";

/**
 * Phase 36da.99.gj — thin warning bar shown at the top of the app during the
 * GRACE window (subscription expired but still inside grace_days).  Counts
 * down to the lock date; admins get a "Pay now" that opens the Subscription
 * page where they can pick a 1/3/6/12-month plan.
 */
export default function GraceBanner() {
  const { subscription: sub } = useAuth();

  if (!sub || sub.status !== "GRACE") return null;

  const rupees = sub.amountRupees ?? (sub.amountPaise != null ? Math.round(sub.amountPaise / 100) : "");
  const days = sub.daysLeft ?? 0;

  const goPay = () => { window.location.hash = "subscription"; };

  return (
    <div style={{
      flexShrink: 0,
      display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
      background: "var(--warn-bg)", color: "var(--warn)",
      borderBottom: `1px solid var(--warn-bdr)`,
      // Phase 36da.99.bp — slimmed to ~30px so it reads as a secondary
      // alert strip ABOVE the 46px TopBrandBar.  The brand bar should
      // dominate visually; this banner is a passing notification, not
      // a primary chrome element.
      padding: "5px 16px", fontSize: 12, fontFamily: "var(--font-ui)",
      lineHeight: 1.3,
    }}>
      <AlertTriangle size={13} style={{ flexShrink: 0 }} />
      <span style={{ fontWeight: 700 }}>
        Subscription expired on {String(sub.paidUntil)}.
      </span>
      <span style={{ color: "var(--text-1)", fontSize: 11.5 }}>
        Access locks in {days} day{days === 1 ? "" : "s"} — please renew{rupees ? ` (₹${rupees})` : ""}.
      </span>
      {sub.canPay && (
        <button onClick={goPay} style={{
          marginLeft: "auto", background: "var(--warn)", color: "#fff", border: "none",
          borderRadius: 5, padding: "3px 11px", fontSize: 11.5, fontWeight: 700,
          cursor: "pointer", fontFamily: "var(--font-ui)",
          letterSpacing: "0.02em",
        }}>
          Pay now
        </button>
      )}
    </div>
  );
}